import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { auth } from "../firebase";
import api from "../api/client";
import { saveOnboardingStep } from "../api/auth";
import { trackCalendarConnected, trackOnboardingStepComplete } from "../lib/analytics";
import {
  getCalendarCallbackErrorMessage,
  getCalendarReturnPath,
} from "../lib/calendarOAuthCallback";

const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;

    const run = async () => {
      const error = searchParams.get("error");
      const errorDescription = searchParams.get("error_description");
      const code = searchParams.get("code");
      const state = searchParams.get("state");

      if (error || !code) {
        navigate(
          getCalendarReturnPath(
            state,
            false,
            errorDescription || error || "Calendar authorization was cancelled or failed."
          ),
          { replace: true }
        );
        return;
      }

      const unsub = auth.onAuthStateChanged(async (user) => {
        if (!user) {
          unsub();
          navigate(
            getCalendarReturnPath(
              state,
              false,
              "Please sign in before connecting Google Calendar."
            ),
            { replace: true }
          );
          return;
        }

        try {
          await user.getIdToken(true);

          await api.post("/connect_calendar", { provider: "google", code });
          trackCalendarConnected("google");

          if (state === "onboarding") {
            await saveOnboardingStep({ step: "calendar", step_status: "complete" });
            trackOnboardingStepComplete(5, "calendar_connection", true);
          }

          navigate(getCalendarReturnPath(state, true), { replace: true });
        } catch (e) {
          console.error("❌ Google OAuth callback exception:", e);
          navigate(
            getCalendarReturnPath(
              state,
              false,
              getCalendarCallbackErrorMessage(e, "Failed to connect Google Calendar.")
            ),
            { replace: true }
          );
        } finally {
          unsub();
        }
      });
    };

    run();
  }, [searchParams, navigate]);

  return <div>🔄 Connecting your Google Calendar…</div>;
};

export default GoogleCallback;
